/**
 * Which HTTP statuses the edge-resolve retry ladder must NOT retry.
 *
 * 2026-09-07: `/v1/api/servers/resolve` answers 406 for an unsupported file type (and, until
 * the professorx fix of the same day, for any file name containing a comma). The ladder retried
 * it five times with exponential backoff, so every such user waited ~31 s for the same answer.
 * A 4xx is a verdict about the request, not a transient fault — except 408 (request timeout)
 * and 429 (rate limit), which are exactly the transient ones.
 */
export function isTerminalResolveStatus(status: unknown): boolean {
    if (typeof status !== 'number' || !Number.isFinite(status)) return false;
    if (status < 400 || status >= 500) return false;
    return status !== 408 && status !== 429;
}
